<organization-top-navbar></organization-top-navbar>
<div class="w-full lg:w-[90%] px-4 m-auto">
  <div class="py-4">
    <button class="gap-2 flex items-center" (click)="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-6 stroke-[#0D6EFD]">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
      </svg>
      <p class="font-medium text-sm text-[#0D6EFD]">{{ "PARKIFLY.BACK_BUTTONS.NEW_SEARCH" | transloco }}</p>
    </button>
  </div>
  <div class="DinaUppgifter text-black text-lg font-bold leading-loose">{{'PARKIFLY.STEPPER.CHOOSE_PARKING' |
    transloco}}</div>
  <div class="flex flex-col md:flex-row gap-4 mt-4" ngClass="showSubscription ? 'justify-center' : 'justify-start'">
    <pf-psf-info type="departure" class="flex basis-1/2" [psfCardInfo]="departureInfo"></pf-psf-info>
    @if (!showSubscription && !isParkingPermitUser) {
    <pf-psf-info type="arrival" class="flex basis-1/2" [psfCardInfo]="arrivalInfo"></pf-psf-info>
    }
  </div>
</div>

@if (site?.toLowerCase() != 'nazar' && site?.toLowerCase() != 'tui' && !isParkingPermitUser) {
<div class="w-full lg:w-[90%] px-4 m-auto mt-4 flex flex-col sm:flex-row gap-4">
  <div
    class="w-full max-w-[500px] bg-neutral-50 rounded-xl border border-neutral-300 justify-start items-end inline-flex">
    <div class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
      <mat-form-field appearance="fill" class="w-full ">
        <mat-label> {{ 'PARKIFLY.FORM.DISCOUNT_CODE_LABEL' | transloco }} </mat-label>
        <input matInput [formControl]="discountCodeControl" placeholder="" class="focus:ring-0">
        @if (this.isDiscountCodeWrong) {
        <span class="error-text-12px">
          {{ 'PARKIFLY.FORM.DISCOUNT_CODE_ERROR' | transloco }}
        </span>
        }
      </mat-form-field>
    </div>
  </div>
  <button (click)="applyDiscountCode()"
    [disabled]="site === 'quality-xpo-arlanda' && discountCodeControl.value?.toLowerCase() === 'resa'"
    [ngClass]="{'bg-[#FFC700] hover:bg-[#FFD833]': !(site === 'quality-xpo-arlanda' && discountCodeControl.value?.toLowerCase() === 'resa'), 'bg-[#FFE871] text-[#4B4A4A] cursor-not-allowed': site === 'quality-xpo-arlanda' && discountCodeControl.value?.toLowerCase() === 'resa'}"
    class="Btn rounded-xl self-stretch px-8 py-3 justify-center items-center gap-2 inline-flex text-black">
    {{ 'PARKIFLY.FORM.APPLY_DISCOUNT_CODE' | transloco }}
  </button>
</div>
}


@if(loaded) {
<div class="w-full lg:w-[90%] px-4 m-auto mt-4">
  <div class="
    justify-start
    gap-4 grid grid-cols-1 sm:grid-cols-2 min-[1200px]:grid-cols-3 2xl:grid-cols-4 min-[1921px]:grid-cols-5">
    @for (item of parkings; track $index) {
    <pf-parking-card (btnClick)="pickParking(item)" [parkingCardInfo]="item" [parkingDetails]="(item.features)"
      [parkingDays]="item.nrOfDays" [isPreSelected]="isPreSelectedParking(item)"></pf-parking-card>
    } @empty {
    <li>{{'PARKIFLY.CHOOSE_PARKING.NO_PARKINGS' | transloco}}</li>
    }
  </div>
</div>
}@else {
@if(timeoutError){
<div class="w-full lg:w-[90%] px-4 m-auto mt-4 flex flex-col sm:flex-row gap-4">
  <button (click)="applyDiscountCode()"
    class="Btn rounded-xl self-stretch px-8 py-3 justify-center items-center gap-2 inline-flex bg-[#FFC700] hover:bg-[#FFD833] text-black">
    {{'FORM.TRY_AGAIN' | transloco}}
  </button>
</div>
}
@else{
<div class="w-[95%] lg:w-[90%] m-auto mt-4">
  <div class="
    justify-start
    parkings-container gap-4">

    <div
      class="flex-col justify-start items-center flex px-6 bg-white rounded-lg border border-zinc-200 h-full animate-pulse">

      <div class="Heading w-full py-6 border-b border-zinc-200 justify-start items-center gap-4 inline-flex">
        <div class="w-14 h-14 bg-zinc-200 rounded-full"></div>
        <div class="flex-col justify-end items-start gap-1 inline-flex">
          <div class="h-6 w-48 bg-zinc-200 rounded"></div>
        </div>
      </div>

      <ul class="pt-4 CardList w-full justify-end items-center gap-3 border-b border-zinc-200 pb-8 flex flex-col">
        <li class="ListItem self-stretch justify-start items-start gap-3 flex">
          <div class="CheckIcon w-6 h-6 bg-zinc-200 rounded-xl"></div>
          <div class="TextWrap grow shrink basis-0 flex-col justify-start items-start flex">
            <div class="h-4 w-full bg-zinc-200 rounded"></div>
          </div>
        </li>
        <li class="ListItem self-stretch justify-start items-start gap-3 flex">
          <div class="CheckIcon w-6 h-6 bg-zinc-200 rounded-xl"></div>
          <div class="TextWrap grow shrink basis-0 flex-col justify-start items-start flex">
            <div class="h-4 w-full bg-zinc-200 rounded"></div>
          </div>
        </li>
        <!-- Repeat above li elements as needed to simulate the number of list items -->
      </ul>

      <div class="Actions w-full pt-4 pb-8 border-zinc-200 flex-col justify-end items-start gap-4 flex">
        <div>
          <div class="mb-1 h-4 w-32 bg-zinc-200 rounded"></div>
          <div class="h-8 w-24 bg-zinc-200 rounded"></div>
        </div>

        <div
          class="ListItem w-32 h-9 px-3 py-1.5 bg-zinc-200 rounded-lg justify-start items-center gap-3 inline-flex m-auto">
          <div class="w-6 h-6 bg-zinc-300 rounded-full"></div>
          <div class="TextWrap flex-col justify-start items-start inline-flex">
            <div class="h-4 w-24 bg-zinc-200 rounded"></div>
          </div>
        </div>

      </div>
    </div>


    <div
      class="flex-col justify-start items-center flex px-6 bg-white rounded-lg border border-zinc-200 h-full animate-pulse">

      <div class="Heading w-full py-6 border-b border-zinc-200 justify-start items-center gap-4 inline-flex">
        <div class="w-14 h-14 bg-zinc-200 rounded-full"></div>
        <div class="flex-col justify-end items-start gap-1 inline-flex">
          <div class="h-6 w-48 bg-zinc-200 rounded"></div>
        </div>
      </div>

      <ul class="pt-4 CardList w-full justify-end items-center gap-3 border-b border-zinc-200 pb-8 flex flex-col">
        <li class="ListItem self-stretch justify-start items-start gap-3 flex">
          <div class="CheckIcon w-6 h-6 bg-zinc-200 rounded-xl"></div>
          <div class="TextWrap grow shrink basis-0 flex-col justify-start items-start flex">
            <div class="h-4 w-full bg-zinc-200 rounded"></div>
          </div>
        </li>
        <li class="ListItem self-stretch justify-start items-start gap-3 flex">
          <div class="CheckIcon w-6 h-6 bg-zinc-200 rounded-xl"></div>
          <div class="TextWrap grow shrink basis-0 flex-col justify-start items-start flex">
            <div class="h-4 w-full bg-zinc-200 rounded"></div>
          </div>
        </li>
        <!-- Repeat above li elements as needed to simulate the number of list items -->
      </ul>

      <div class="Actions w-full pt-4 pb-8 border-zinc-200 flex-col justify-end items-start gap-4 flex">
        <div>
          <div class="mb-1 h-4 w-32 bg-zinc-200 rounded"></div>
          <div class="h-8 w-24 bg-zinc-200 rounded"></div>
        </div>

        <div
          class="ListItem w-32 h-9 px-3 py-1.5 bg-zinc-200 rounded-lg justify-start items-center gap-3 inline-flex m-auto">
          <div class="w-6 h-6 bg-zinc-300 rounded-full"></div>
          <div class="TextWrap flex-col justify-start items-start inline-flex">
            <div class="h-4 w-24 bg-zinc-200 rounded"></div>
          </div>
        </div>

      </div>
    </div>


    <div
      class="flex-col justify-start items-center flex px-6 bg-white rounded-lg border border-zinc-200 h-full animate-pulse">

      <div class="Heading w-full py-6 border-b border-zinc-200 justify-start items-center gap-4 inline-flex">
        <div class="w-14 h-14 bg-zinc-200 rounded-full"></div>
        <div class="flex-col justify-end items-start gap-1 inline-flex">
          <div class="h-6 w-48 bg-zinc-200 rounded"></div>
        </div>
      </div>

      <ul class="pt-4 CardList w-full justify-end items-center gap-3 border-b border-zinc-200 pb-8 flex flex-col">
        <li class="ListItem self-stretch justify-start items-start gap-3 flex">
          <div class="CheckIcon w-6 h-6 bg-zinc-200 rounded-xl"></div>
          <div class="TextWrap grow shrink basis-0 flex-col justify-start items-start flex">
            <div class="h-4 w-full bg-zinc-200 rounded"></div>
          </div>
        </li>
        <li class="ListItem self-stretch justify-start items-start gap-3 flex">
          <div class="CheckIcon w-6 h-6 bg-zinc-200 rounded-xl"></div>
          <div class="TextWrap grow shrink basis-0 flex-col justify-start items-start flex">
            <div class="h-4 w-full bg-zinc-200 rounded"></div>
          </div>
        </li>
        <!-- Repeat above li elements as needed to simulate the number of list items -->
      </ul>

      <div class="Actions w-full pt-4 pb-8 border-zinc-200 flex-col justify-end items-start gap-4 flex">
        <div>
          <div class="mb-1 h-4 w-32 bg-zinc-200 rounded"></div>
          <div class="h-8 w-24 bg-zinc-200 rounded"></div>
        </div>

        <div
          class="ListItem w-32 h-9 px-3 py-1.5 bg-zinc-200 rounded-lg justify-start items-center gap-3 inline-flex m-auto">
          <div class="w-6 h-6 bg-zinc-300 rounded-full"></div>
          <div class="TextWrap flex-col justify-start items-start inline-flex">
            <div class="h-4 w-24 bg-zinc-200 rounded"></div>
          </div>
        </div>

      </div>
    </div>


  </div>

</div>
}
}